<!-- 请假 -->
<template>
  <div class="app-container">
    <el-card class="box-card">
      <!-- 搜索-->
      <dynamic-search :data="tableFilterList(tableHead)" @search="dataTableSearch">
        <template v-slot:next>
          <el-button icon="el-icon-plus" @click="$router.push('absence/form')">新增</el-button>
        </template>
      </dynamic-search>
      <edit-data-table
        :head="tableHead"
        :data.sync="list"
        :config="{trigger: 'click', mode: 'cell'}"
        :total="total"
        :offset="offset"
        :page="page"
        :loading="loading"
        stripe
        @handlePageChange="dataTablePageChange"
        @handleSizeChange="dataTableSizeChange"
      >
        <template #toolbar="scope">
          <!-- 查看 -->
          <el-button
            type="text"
            icon="el-icon-view"
            style="color:#4084B7;"
            @click="showById(scope.row)"
          />
          <el-button
            v-if="statusEdit(scope.row.approvalStatus)"
            type="text"
            size="mini"
            icon="el-icon-edit"
            @click="edit(scope.row)"
          ></el-button>
          <!-- <el-button
            v-if="statusAudit(scope.row.approvalStatus)"
            type="text"
            size="mini"
            icon="el-icon-circle-check"
            @click="approve(scope.row)"
          ></el-button> -->
          <!-- <el-button
            v-if="statusAudit(scope.row.approvalStatus)"
            type="text"
            size="mini"
            icon="el-icon-circle-close"
            @click="reject(scope.row)"
          ></el-button>-->
          <el-popover
            v-if="statusAudit(scope.row.approvalStatus)"
            :ref="scope.row.approvalStatus"
            placement="top"
            width="180"
          >
            <p>确定审批通过该请假申请单据吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="$refs[scope.row.approvalStatus].doClose()">取消</el-button>
              <el-button type="primary" size="mini" @click="approve(scope.row)">确定</el-button>
            </div>
            <el-button type="text" size="mini" icon="el-icon-circle-check" slot="reference"></el-button>
          </el-popover>
          <el-popover
            v-if="statusAudit(scope.row.approvalStatus)"
            :ref="scope.row.id"
            placement="top"
            width="180"
          >
            <p>确定退回该请假申请单据吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="$refs[scope.row.id].doClose()">取消</el-button>
              <el-button type="primary" size="mini" @click="reject(scope.row)">确定</el-button>
            </div>
            <el-button type="text" size="mini" icon="el-icon-circle-close" slot="reference"></el-button>
          </el-popover>
          <el-popover
            v-if="statusEdit(scope.row.approvalStatus)"
            :ref="scope.row.id"
            placement="top"
            width="180"
          >
            <p>确定删除本条数据吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="$refs[scope.row.id].doClose()">取消</el-button>
              <el-button
                :loading="delLoading"
                type="primary"
                size="mini"
                @click="subDelete(scope.row.id)"
              >确定</el-button>
            </div>
            <el-button
              type="text"
              size="mini"
              icon="el-icon-delete"
              style="color:red"
              slot="reference"
            ></el-button>
          </el-popover>
        </template>
      </edit-data-table>
    </el-card>
  </div>
</template>

<script>
import "@/components/EditDataTable";
import DynamicSearch from "@/components/DynamicSearch";
import DataTableMixin from "@/mixins/DataTableMixin";
import { deleteAbsence, editAbsence } from "@/api/absence";
import { tableSataus } from "@/views/bill/mixins/status";

export default {
  name: "TaskReport",
  mixins: [DataTableMixin, tableSataus],
  components: {
    DynamicSearch
  },
  data() {
    return {
      delLoading: false,
      tableHead: [
        {
          label: "单据编号",
          prop: "code",
          // query: {
          //   type: "input"
          // },
          align: "left"
        },
        {
          label: "项目号",
          prop: "projectNumber",
          // query: {
          //   type: "input"
          // },
          align: "left"
        },
        {
          label: "请假人",
          prop: "leavePeople",
          align: "center",
          query: {
            type: "input"
          }
        },
        {
          label: "请假类型",
          prop: "leaveType",
          // align: "center",
          formatter: function(value, row) {
            if (value === "调休") {
              return value + `(还剩${row.paidLeaveDays || 0}天)`;
            }
            return value;
          },
          editRender: {
            type: "default",
            name: "ElSelect"
          },
          query: {
            type: "select",
            filterable: true,
            data: [
              { value: "事假", label: "事假" },
              { value: "病假", label: "病假" },
              { value: "调休", label: "调休" }
            ]
          }
        },
        {
          label: "申请人",
          prop: "proposer",
          align: "center",
          query: {
            type: "input"
          }
        },
        {
          label: "开始时间",
          prop: "beginTime",
          align: "center",
          editRender: {
            type: "default",
            name: "ElDatePicker"
          }
          // query: {
          //   type: "date"
          // }
        },
        {
          label: "结束时间",
          prop: "endTime",
          align: "center",
          editRender: {
            type: "default",
            name: "ElDatePicker"
          }
          // query: {
          //   type: "date"
          // }
        },
        {
          label: "请假时长",
          prop: "leaveDays",
          align: "center"
        },
        {
          label: "请假事由",
          prop: "leaveMatter"
        },
        {
          label: "单据状态",
          prop: "approvalStatus",
          align: "center",
          formatter: state => {
            return this.statusName(state);
          },
          query: {
            type: "select",
            filterable: true,
            data: [
              { value: "1", label: "草稿" },
              { value: "2", label: "审批中" },
              { value: "3", label: "已审批" },
              { value: "4", label: "驳回" }
            ]
          }
        }
        // {
        //   label: "备注",
        //   prop: "remark"
        // }
      ]
    };
  },
  created() {
    // 列表数据初始化
    this.$nextTick(() => {
      this.dataTableInit();
    });
  },
  methods: {
    dataTableBeforeInit() {
      this._url = "/leave";
      const premType = "3,4"; // 权限类型【前端权限】
      const params = { page: this.page, size: this.offset, type: premType };
      this._params = Object.assign(params, this._query);
      return true;
    },
    handleDeletes(rows) {
      rows.forEach(element => {
        this.subDelete(element.id);
      });
    },
    subDelete(id) {
      this.delLoading = true;
      deleteAbsence(id)
        .then(res => {
          this.delLoading = false;
          this.$refs[id].doClose();
          this.dleTableChangePage();
          this.dataTableInit();
          this.$notify({
            title: "删除成功",
            type: "success",
            duration: 2500
          });
        })
        .catch(err => {
          this.delLoading = false;
          this.$refs[id].doClose();
          console.log(err);
        });
    },
    edit(data) {
      // console.log(row);
      // this.$router.push("absence/form?id=" + row.id);
      this.$router.push({
        path: "absence/form",
        query: { id: data.id, isShow: false }
      });
    },
    // 查看
    showById(data) {
      this.$router.push({
        path: "absence/form",
        query: { id: data.id, isShow: true }
      });
    },
    // 审批通过
    approve(data) {
      data.approvalStatus = 3;
      this.updata(data);
      this.$refs[data.approvalStatus].doClose()
    },
    // 审批驳回
    reject(data) {
      data.approvalStatus = 4;
      this.updata(data);
      this.$refs[data.id].doClose()
    },
    updata(data) {
      editAbsence(data)
        .then(res => {
          this.dataTableInit();
          this.$notify({
            title: "操作成功",
            type: "success",
            duration: 2500
          });
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
